// extracted by mini-css-extract-plugin
export default {"container":"wall-e-bussines-partner-promotion_container__nz+MX","widget_container":"wall-e-bussines-partner-promotion_widget_container__hokVG"};